module.exports = __webpack_public_path__ + "static/media/nexter.af3055e6.jpg";